import { changesApi } from '../../services/changesApi';
import type { ChangeExtraFields, ChangeFormField } from '../../types/changes';
import { nativeFieldVisible } from './changeFormSchema';
import {
  findNativeField,
  nativeCatalogLabel,
  type ChangeFormValues,
} from './changeValidation';

const NO_MANAGER_MESSAGE =
  'Não há gerente imediato disponível para este solicitante. Cadastre gestor ou gerente imediato em ' +
  'Cadastros → Grupos → Pessoas (nos grupos em que o solicitante participa).';

/**
 * Validação assíncrona antes de avançar para subtarefas / enviar create.
 * O campo pode ser obrigatório no cadastro mesmo quando a lista de opções vem vazia.
 */
export async function validateImmediateManagerPickForSubmit(
  form: ChangeFormValues,
  fields: ChangeFormField[] | null | undefined,
  extras: ChangeExtraFields | null | undefined,
  requesterId: number,
): Promise<string | null> {
  const extrasMap = extras || {};
  const visible = nativeFieldVisible(fields, 'requester_manager_group_id', form, extrasMap);
  if (!visible) return null;

  const field = findNativeField(fields, 'requester_manager_group_id');
  const required = Boolean(field?.is_required);
  const label = nativeCatalogLabel(fields, 'requester_manager_group_id', 'o gerente imediato (Transporte)');

  if (!requesterId) {
    return required ? 'Selecione o solicitante antes de escolher o gerente imediato.' : null;
  }

  let payload;
  try {
    payload = await changesApi.getRequesterManagerOptions(requesterId, String(form.change_type));
  } catch {
    return 'Não foi possível verificar gerentes imediatos. Tente novamente.';
  }

  if (!payload.uses_immediate_manager) {
    return null;
  }

  const options = payload.picker_options || [];

  if (options.length === 0) {
    return required ? NO_MANAGER_MESSAGE : null;
  }

  const groupId = form.requester_manager_group_id || 0;
  if (required && options.length > 1 && !groupId) {
    return `Selecione ${label}.`;
  }

  if (required && options.length === 1 && !groupId) {
    return `Selecione ${label}.`;
  }

  if (groupId && !options.some((item) => item.group_id === groupId)) {
    return `${NO_MANAGER_MESSAGE} Atualize a seleção do campo ${label}.`;
  }

  return null;
}
